export default __webpack_public_path__ + "static/media/bg-topo-principal.d7e75c74.png";